var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#C79A00",
  fillOpacity: 0.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m30 17.847c0 0.1691-0.1122 0.3667-0.3358 0.5914l-4.3279 4.2636 1.0081 6.0369v0.2115c0 0.1976-0.0415 0.3374-0.126 0.4223-0.0838 0.1405-0.196 0.2107-0.3358 0.2107-0.1122 0-0.2804-0.0556-0.5048-0.169l-5.3782-2.8286-5.3782 2.8286c-0.2243 0.1134-0.3918 0.169-0.504 0.169-0.1683 0-0.2943-0.0702-0.378-0.2107-0.0838-0.0849-0.126-0.2247-0.126-0.4223 0-0.0849 0.0138-0.1544 0.0422-0.2115l1.0081-6.0369-4.3694-4.2636c-0.196-0.3096-0.2943-0.5072-0.2943-0.5914 0-0.3087 0.2243-0.4925 0.6723-0.5488l6.0505-0.8863 2.6891-5.4887c0.1674-0.3374 0.3634-0.5064 0.5877-0.5064 0.2244 0 0.4203 0.169 0.5885 0.5064l2.6891 5.4887 6.0505 0.8863c0.448 0.0563 0.6723 0.2401 0.6723 0.5488z",
  clipRule: "evenodd",
  fill: "#001246",
  fillRule: "evenodd"
})));
export default SvgStar;